export default "__VITE_ASSET__Dph0HiH$__"